import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';
  

  const InitializeDatadogRum = () => {
    if(process.env.REACT_APP_DD_APP_ID && process.env.REACT_APP_DD_CLIENT_TOKEN){
        datadogRum.init({
            applicationId: process.env.REACT_APP_DD_APP_ID,
            clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
            site: 'us5.datadoghq.com',
            service:'support',
            env: process.env.REACT_APP_DD_ENV,
            version: process.env.REACT_APP_COMMIT_ID,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            trackUserInteractions: true,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel:'mask-user-input',
            enableExperimentalFeatures: ['clickmap']
          });
          datadogRum.startSessionReplayRecording();

        // Initialize Datadog Browser Logs
        datadogLogs.init({
            clientToken: process.env.REACT_APP_DD_CLIENT_TOKEN,
            site: 'us5.datadoghq.com',
            service: 'support',
            env: process.env.REACT_APP_DD_ENV,
            version: process.env.REACT_APP_COMMIT_ID,
            forwardErrorsToLogs: true,
            sessionSampleRate: 100,
        });
    }
  }

  window.DatadogRumSetUser = function (email) {
    if(datadogRum){
        datadogRum.setUser({
            email: email
        })
    }
    if(datadogLogs){
        datadogLogs.setUser({
            email: email
        })
    }
  }
  

  
export default InitializeDatadogRum
export { datadogLogs }